import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage, OptionDsType } from "@/types/FmsTypes";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";
import { transPgToPagination } from "../../../../base/app/appModel";
import { IAccountSummary, ICustomerAccountSummary } from "../../../AccountTypes";
import { IMdCustomerFields } from "../../../../base/customer/customerService";
import { IMdOrgDetail, orgService } from "../../../../base/org/orgService";
import { ITreeData } from "../../../../base/dict/dictModel";
import { message } from "antd";
import { useGlobalModel } from "@/model/globalModel";
import { accountShopService } from "@/views/account/AccountShopService";
import { accountService } from "@/views/account/AccountService";
import { convertRes2Blob } from "@/utils/exportFile";

export const useSummaryModel = createModel(function () {
    const { user: { shopCode } } = useGlobalModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdCustomerFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ICustomerAccountSummary[]>([]);

    const [summaryData, setSummaryData] = useState<IAccountSummary>({});
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<ICustomerAccountSummary[]>([]);
    const [selectedData, setSelectedData] = useState<ICustomerAccountSummary>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [customerTypeDs, setCustomerType] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();
    const [exportLoading, setExportLoading] = useState(false)
    const [removeExportLoading, setRemoveExportLoading] = useState(false)
    //账户初始化
    const [initAccountVisible, setInitAccountVisible] = useState<boolean>(false);


    //切换门店清除缓存
    useEffect(()=>{
        setDataSource([]);
        setSelectedRowKeys([]);
    },[shopCode]);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdCustomerFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSelectedRowKeys([]);
        setSearchParam({});
        loadData(initPgCfg, {})
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchVlaue: IMdCustomerFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchVlaue,
            shopCode,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountShopService.customerSummaryPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        let { retData: summaryData } = await accountShopService.customerSummary(searchParams);
        setSummaryData(summaryData);
        clearSelectData();
    }

    const loadDataAll = async () => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchParam,
            shopCode,
            page: {
                pageSize: 1000000,
                pageNum: 1
            }
        }
        let { retData } = await accountShopService.customerSummaryPage(searchParams);
        const { records, ...pg } = retData;
        if (records && records.length > 0) {
            setSelectedRowKeys(records);
            setInitAccountVisible(true);
        } else {
            message.warning("没有符合条件的数据")
        }
    }

    const getSelectedData = () => {
        return selectedData;
    }

    const onExport = async (type: 'customer' | 'account'|'removeAccount') => {
        
        try {
            const searchData = selectedRowKeys.length > 0 ? {
                ...defaultMdCmParam,
                ids: selectedRowKeys.map(item => item.key).join(','),
                shopCode,
                // page: {
                //     pageSize: -1,
                //     pageNum: 1
                // }
            } : {
                ...defaultMdCmParam,
                ...searchParam,
                shopCode,
                // page: {
                //     pageSize: -1,
                //     pageNum: 1
                // }
            }
            if (type === 'customer') {
                setExportLoading(true)
                const result = await accountShopService.customerSummaryExport(searchData)
                convertRes2Blob(result)
                setExportLoading(false)
            }else if(type === 'removeAccount') {
                setRemoveExportLoading(true)
                const result = await accountShopService.customerAccountExport({...searchData,isExclude:true})
                convertRes2Blob(result)
                setRemoveExportLoading(false)
            } else {
                const result = await accountShopService.customerAccountExport(searchData)
                convertRes2Blob(result)
            }
            
        } catch (error) {
            setExportLoading(false)
            setRemoveExportLoading(false)
        }
    }
    return {
        /***field***/
        orgDs, appDs, setAppDs,
        initPgCfg,
        customerTypeDs,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        summaryData,
        setOrgDs,
        setCustomerType,
        setSelectedData,
        exportLoading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, loadDataAll,
        updatePgCfg,
        getSelectedData,
        removeExportLoading, setRemoveExportLoading,
        initAccountVisible, setInitAccountVisible,
        onExport,
        setSearchParam
    }
});
